// Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';

// material-ui (neutral container only)
import Box from '@mui/material/Box';

export default class PageWithSidebar extends React.Component {
  render() {
    const { sidebarContent, children, SidebarPusherProps } = this.props;

    return (
      <Box
        sx={{
          display: 'flex',
          flex: '1 1 auto',
          overflow: 'hidden',
          border: 'none',
          margin: 0,
          borderRadius: 0,
          boxShadow: 'none'
        }}
      >
        {/* Sidebar */}
        <Box
          sx={{
            margin: 0,
            borderRadius: 0,
            flex: '0 0 auto',
            position: 'relative',
            overflowY: 'scroll',
            width: '260px',
            backgroundColor: '#1b1c1d',
            color: '#ffffff80'
          }}
        >
          {sidebarContent}
        </Box>

        {/* Content */}
        <Box
          id="page-with-sidebar-content"
          sx={{
            flex: '1 1 auto',
            height: '100%',
            overflow: 'auto',
            width: 'calc(100% - 260px)'
          }}
          {...SidebarPusherProps}
        >
          {children}
        </Box>
      </Box>
    );
  }
}
